import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Chip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

import { useUserBoardEpic } from "../../../../reactQuery/epics";
import DownArrow from "../../../../styles/svg/downArrow.svg";
import { addAllEpic, addEpic } from "../../../../redux/SearchSlice";
import { useCustomSearchParams } from "../../../../hooks/useCustomSearchParams";
import { useResponsive } from "../../../../hooks/useResponsive";
import { useUserWorkflowList } from "../../../../reactQuery/workflows";
import { useMineCards } from "../../../../reactQuery/cards";
import CustomMenuItem from "../../../../components/Menu/CustomMenuItem";
import CustomMenu from "../../../../components/Menu";
import { CustomButton } from "../../../../components/Button/Button";
import SelectAllBoardMenuItem from "./SelectAllBoardMenuItem";
import BoardList from "./BoardList";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function Epics({ isAssignToMe = false }) {
  const dispatch = useDispatch();
  const checkedList = useSelector((state) => state.search.epicSearch);
  const board_id = useSelector((state) => state.search.boardSearch)[0];
  const { epic } = useUserBoardEpic(board_id);
  const epicResponseData = epic?.data?.data?.responseData || [];
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const isMobile = useResponsive("down", "md");

  const [milestones, updateParams] = useCustomSearchParams("milestone");
  const [assignedMilestone, setAssignedMilestone] = useState([]);
  const user = useSelector((state) => state.search.myTaskUser);
  const [selectedAll, setSelectedAll] = useState(false);

  const { userWorkflows } = useUserWorkflowList();
  const genericWorkflowId = userWorkflows?.data?.data?.responseData?.find(
    (workflow) => workflow.is_generic
  )?.workflow_id;
  const {
    data: mineCards,
    isLoading,
    refetch,
    isRefetching,
  } = useMineCards(user || [], "", "", "", genericWorkflowId);

  useEffect(() => {
    if (isAssignToMe && epicResponseData && mineCards) {
      let boardsWithCards = new Set(
        mineCards?.data.data.responseData?.map((card) => card.card.epic_id) ||
        []
      );
      const filteredBoards = epicResponseData.filter((epic) =>
        boardsWithCards.has(epic.epic_id)
      );
      setAssignedMilestone(filteredBoards);
    } else {
      setAssignedMilestone(epicResponseData);
    }
  }, [epicResponseData, isLoading]);

  const selectEpic = (event, id) => {
    if (checkedList.includes(id)) {
      setSelectedAll(false);
      !isMobile &&
        updateParams(
          "milestone",
          checkedList.filter((el) => el != id)
        );
      isMobile && dispatch(addAllEpic([]));
      dispatch(addEpic(id));
    } else {
      !isMobile && updateParams("milestone", [...checkedList, id]);
      isMobile && dispatch(addAllEpic([]));
      dispatch(addEpic(id));
    }
  };

  const selectAll = (e) => {
    if (e.target.checked) {
      !isMobile &&
        updateParams(
          "milestone",
          assignedMilestone?.map((el) => el.epic_id)
        );
      dispatch(addAllEpic(assignedMilestone?.map((el) => el.epic_id)));
      setSelectedAll(true);
    } else {
      dispatch(addAllEpic([]));
      !isMobile && updateParams("milestone", []);
      setSelectedAll(false);
    }
  };

  useEffect(() => {
    if (milestones) {
      const milestonesTemp = milestones
        .split(",")
        .map((milestone) => milestone * 1);

      milestonesTemp.length > 1
        ? dispatch(addAllEpic(milestonesTemp))
        : dispatch(addEpic(milestones));
    }
  }, []);

  const handleDeleteMilestones = () => {
    updateParams("milestone", []);
    dispatch(addAllEpic([]));
  };

  const selectedMilestoneCount = checkedList.length;

  return (
    <div className={isMobile ? "mt-2" : "ml-2"}>
      {isMobile ? (
        <Accordion className="filter-accordion">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header">
            <Typography component="span">By Milestone</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: "0px 12px 12px" }}>
            <div className="filter-accordion-content">
              {/* {epic && assignedMilestone?.length > 0 && (
                <SelectAllBoardMenuItem
                  className={"custom-border"}
                  label="Select all milestone"
                  onChange={selectAll}
                  checked={selectedAll}
                />
              )} */}
              {epic && assignedMilestone?.length > 0 && (
                <BoardList
                  checkedList={checkedList}
                  boards={assignedMilestone}
                  onSelect={selectEpic}
                  isEpic={true}
                />
              )}
              {epic && !assignedMilestone?.length && (
                <CustomMenuItem>No milestone found</CustomMenuItem>
              )}
            </div>
            {/* </Box> */}
          </AccordionDetails>
        </Accordion>
      ) : (
        <CustomButton
          variant="outlined"
          color="primary"
          id="epics-board-dropdown"
          aria-haspopup="true"
          onClick={(event) => setAnchorEl(event.currentTarget)}
          endIcon={<img src={DownArrow} alt="down arrow" />}
          className="filter-btn white-button ml-2 epic-filter-button">
          <Chip
            label={
              <div className="d-flex justify-content-space-between">
                <p className="filter-name">milestone</p>
                <p className="filter-count">
                  {selectedMilestoneCount === 0 ? "" : selectedMilestoneCount}
                </p>
              </div>
            }
            className="filter-chip"
            {...(selectedMilestoneCount > 0
              ? { onDelete: handleDeleteMilestones }
              : {})}
          />
        </CustomButton>
      )}
      <CustomMenu
        id="user-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        className="assign-board-owner-list">
        {epic && assignedMilestone?.length > 0 && (
          <SelectAllBoardMenuItem
            className={"custom-border"}
            label="Select all milestone"
            onChange={selectAll}
            checked={selectedAll}
          />
        )}

        {epic && assignedMilestone?.length > 0 && (
          <BoardList
            checkedList={checkedList}
            boards={assignedMilestone}
            onSelect={selectEpic}
            isEpic={true}
          />
        )}

        {epic && !assignedMilestone?.length && (
          <CustomMenuItem>No milestone found</CustomMenuItem>
        )}
      </CustomMenu>
    </div>
  );
}
export default Epics;
